import classNames from 'classnames';
import React from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  onAddProfile?: () => void;
  wrapperClassName?: string;
  children: React.ReactNode;
}

const ProfilesWrapper = ({ wrapperClassName, onAddProfile, children }: IProps) => (
  <div className={classNames('profiles-list', wrapperClassName)}>
    {onAddProfile ? (
      <Button onClick={onAddProfile} appearance="secondary" stretched>
        <Icon name={Icons.Plus} size={16} color={theme.colors.mainblue} />
      </Button>
    ) : null}

    {children}
  </div>
);

export default ProfilesWrapper;
